import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEyeOpen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eye-open, show, see, reveal, look, visible"><path d="M2 11.9999C6.82745 2.33329 17.1725 2.3334 22 12C17.1725 21.6666 6.82745 21.6665 2 11.9999Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconEyeOpen;
